import React, { useState } from 'react';
import Modal from 'react-modal';
import { ZINDEX_MODAL } from './AppConstants';

const IntroModal = () => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        closeTimeoutMS={1000}
        onRequestClose={(e) => {
          e.stopPropagation();
          setIsOpen(false);
        }}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            background: 'transparent',
            border: 'none',
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            zIndex: ZINDEX_MODAL,
          },
        }}>
        <img
          alt='Welcome'
          src='/images/faq_popup.png'
          style={{ borderRadius: 30 }}
          onClick={() => {
            setIsOpen(false);
          }}
        />
      </Modal>
    </>
  );
};

export default IntroModal;
